// EARLY BLACK FRIDAY shared cart helper (builder + quick view).
// Same request and events as the theme's product form / PDP selector, so the cart drawer, cart count and
// bundled sections behave exactly like a normal add to cart.
(function () {
  if (window.ebfCart) return;
  window.ebfCart = {
    async add(items, target) {
      const sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }));
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const emit = target || document;
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: sectionsToBundle.join(',') }),
      });
      const json = await response.json();
      if (!response.ok) {
        emit.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: json.description } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return false;
      }
      const settings = (window.themeVariables && window.themeVariables.settings) || {};
      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = root + 'cart';
        return true;
      }
      const cart = await (await fetch(root + 'cart.js')).json();
      cart.sections = json.sections;
      emit.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: Object.prototype.hasOwnProperty.call(json, 'items') ? json.items : [json], cart },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart },
      }));
      return true;
    },
  };
})();
